// Standalone function to handle wood type stain logic
function handleWoodTypeStainLogic(container) {
  const woodTypeOption = container.querySelector('[data-option-type="wood-type"]');
  
  // Look for stain option - try multiple selectors for different implementations
  let stainOption = container.querySelector('[data-option-type="stain"]');
  
  // If not found, try custom swatch picker structures
  if (!stainOption) {
    stainOption = document.querySelector('.customization-section.reclaimed-barnwood_stain_swatch_set');
  }
  if (!stainOption) {
    stainOption = document.querySelector('.customization-section .swatch_container');
  }
  if (!stainOption) {
    stainOption = document.querySelector('.ProductForm__Option .StainLabel')?.closest('.ProductForm__Option, .customization-section');
  }
  
  if (!woodTypeOption || !stainOption) {
    return;
  }
  
  // Get selected wood type value
  let woodTypeValue = '';
  
  // Check for select dropdown
  const selectElement = woodTypeOption.querySelector('select');
  if (selectElement) {
    const selectedOption = selectElement.querySelector('option[selected]') || selectElement.options[selectElement.selectedIndex];
    woodTypeValue = selectedOption ? selectedOption.value : '';
  } else {
    // Check for radio button (button/swatch style)
    const checkedInput = woodTypeOption.querySelector('input:checked, input[checked]');
    
    if (checkedInput) {
      // Try to get value from the input itself
      woodTypeValue = checkedInput.value || checkedInput.getAttribute('value') || '';
    }
  }
  
  // Normalize and check if Reclaimed Barnwood is selected
  woodTypeValue = woodTypeValue.toLowerCase().trim();
  
  const isReclaimedBarnwood = woodTypeValue.includes('reclaimed') && woodTypeValue.includes('barnwood');
  
  if (isReclaimedBarnwood) {
    // Hide stain option
    stainOption.style.display = 'none';
    stainOption.setAttribute('data-hidden', 'true');
  } else {
    // Show stain option
    stainOption.style.display = '';
    stainOption.removeAttribute('data-hidden');
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          handleWoodTypeStainLogic(this);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
        
        // Initialize immediately
        handleWoodTypeStainLogic(this);
        // Also run after a brief delay to catch any dynamic content
        setTimeout(() => handleWoodTypeStainLogic(this), 50);
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}

// Global initialization for wood type stain logic
document.addEventListener('DOMContentLoaded', function() {
  // Find all variant-selects elements
  const variantSelects = document.querySelectorAll('variant-selects');
  
  variantSelects.forEach((container) => {
    handleWoodTypeStainLogic(container);
  });
  
  // Also try with body if variant-selects not found
  if (variantSelects.length === 0) {
    handleWoodTypeStainLogic(document.body);
  }
});
